import { useCommonAuthProvider } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import useFetcher from 'app/_utils/data/useFetcher';

import { Membership } from 'shared/src/types';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';

const GET_MEMBERSHIPS_URL = `${process.env.ZEUS_API_URL}/v2/system/memberships`;

export const useGetMemberships = (fetchAll: boolean = false) => {
  const { fetcher } = useFetcher();
  const { user } = useCommonAuthProvider();
  const userId = user?.sub;

  const fetchUrl = `${GET_MEMBERSHIPS_URL}${fetchAll ? '?allMemberships=true' : ''}`;
  const key = userId ? `${fetchUrl}:${userId}` : null;

  return useSWR<Membership[], unknown>(
    key,
    () => fetcher(fetchUrl) as Promise<Membership[]>,
    {
      revalidateOnFocus: false,
    },
  );
};

export const useGetMembershipsMutation = (fetchAll: boolean = false) => {
  const { fetcher } = useFetcher();
  const { user } = useCommonAuthProvider();
  const userId = user?.sub;

  const fetchUrl = `${GET_MEMBERSHIPS_URL}${fetchAll ? '?allMemberships=true' : ''}`;
  const key = userId ? `${fetchUrl}:${userId}` : null;

  return useSWRMutation<Membership[], unknown>(
    key,
    async () => {
      if (!userId) {
        throw new Error('Cannot fetch memberships: user ID is not available');
      }

      return fetcher(fetchUrl) as Promise<Membership[]>;
    },
  );
};
